import { render, staticRenderFns } from "./BasisSvgIcon.vue?vue&type=template&id=25119a3c&scoped=true&"
import script from "./BasisSvgIcon.vue?vue&type=script&lang=js&"
export * from "./BasisSvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./BasisSvgIcon.vue?vue&type=style&index=0&id=25119a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25119a3c",
  null
  
)

export default component.exports